import { render } from "./SingleLayout.vue?vue&type=template&id=7148c5ff&scoped=true"
import script from "./SingleLayout.vue?vue&type=script&lang=js"
export * from "./SingleLayout.vue?vue&type=script&lang=js"

import "./SingleLayout.vue?vue&type=style&index=0&id=7148c5ff&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7148c5ff"]])

export default __exports__